import { DynamicResourcesPackage } from "resources/DynamicResourcesPackage";

export class NoCacheDynamicPackage extends DynamicResourcesPackage {
    private static readonly usagesMap: Map<string, number> = new Map();

    private readonly cacheTag: string;

    public constructor(cacheTag: string) {
        super();
        this.cacheTag = `?${cacheTag}`;
        this.trackUsages();
    }

    public override resource<T>(name: string): T {
        return super.resource<T>(name + this.cacheTag);
    }

    public override add(path: string): void {
        super.add(path + this.cacheTag);
    }

    public override destroy(): void {
        const packageName = this.getPackageName();
        let currentUsages = NoCacheDynamicPackage.usagesMap.get(packageName);
        NoCacheDynamicPackage.usagesMap.set(packageName, --currentUsages);
        if (currentUsages !== 0) {
            return;
        }
        super.destroy();
    }

    private trackUsages(): void {
        const packageName = this.getPackageName();
        if (!NoCacheDynamicPackage.usagesMap.has(packageName)) {
            NoCacheDynamicPackage.usagesMap.set(packageName, 1);
        }
        else {
            let currentUsages = NoCacheDynamicPackage.usagesMap.get(packageName);
            NoCacheDynamicPackage.usagesMap.set(packageName, ++currentUsages);
        }
    }

    private getPackageName(): string {
        return `${Object.getPrototypeOf(this).constructor.name}_${this.cacheTag}`;
    }
}